import type { ReactElement, ReactNode } from "react";
import {
  ArrowDownUp,
  ArrowRightLeft,
  Ban,
  BookOpen,
  Calculator,
  CalendarDays,
  CakeSlice,
  CheckCheck,
  ChefHat,
  Circle,
  ClipboardList,
  Clock3,
  FileText,
  Hash,
  Image,
  Keyboard,
  Layers,
  ListChecks,
  ListOrdered,
  Link2,
  LockKeyhole,
  LogIn,
  LogOut,
  Mail,
  MapPin,
  NotebookPen,
  NotebookText,
  Package,
  Palette,
  Percent,
  Phone,
  QrCode,
  ReceiptText,
  Ruler,
  Scale,
  Search,
  Shapes,
  ShoppingBasket,
  Truck,
  SlidersHorizontal,
  Store,
  Tag,
  TextCursorInput,
  TriangleAlert,
  UserRound,
  Users,
  Weight,
  Flame,
  Landmark,
} from "lucide-react";
import "./iconLabel.css";

// Shared visual vocabulary. Pick a meaning explicitly; never infer it from translated UI copy.
export const UI_ICONS = {
  pantry: ShoppingBasket,
  recipe: BookOpen,
  baking: ChefHat,
  order: ClipboardList,
  group: CakeSlice,
  ingredient: ShoppingBasket,
  method: ListOrdered,
  customer: UserRound,
  date: CalendarDays,
  email: Mail,
  phone: Phone,
  address: MapPin,
  delivery: Truck,
  link: Link2,
  reference: Hash,
  qrCode: QrCode,
  notes: NotebookPen,
  inquiry: NotebookText,
  image: Image,
  appearance: Palette,
  category: Tag,
  name: TextCursorInput,
  supplier: Store,
  business: Store,
  banking: Landmark,
  packaging: Package,
  price: ReceiptText,
  costing: Calculator,
  quantity: Hash,
  weight: Weight,
  density: Scale,
  conversion: ArrowRightLeft,
  dimension: Ruler,
  shape: Shapes,
  pan: Circle,
  output: Layers,
  servings: Users,
  time: Clock3,
  markup: Percent,
  settings: SlidersHorizontal,
  search: Search,
  sort: ArrowDownUp,
  document: FileText,
  password: LockKeyhole,
  login: LogIn,
  logout: LogOut,
  shortcuts: Keyboard,
  warning: TriangleAlert,
  draft: ClipboardList,
  confirmed: ListChecks,
  inProgress: Flame,
  completed: CheckCheck,
  cancelled: Ban,
};

export type UiIconName = keyof typeof UI_ICONS;

/** Compose inside the actual heading/label/dt so semantics and accessible names stay intact. */
export function IconLabel({
  icon,
  size = "label",
  children,
}: {
  icon: UiIconName;
  size?: "label" | "section" | "title";
  children: ReactNode;
}): ReactElement {
  const Icon = UI_ICONS[icon];
  return (
    <span className="icon-label" data-icon-size={size} data-ui-icon={icon}>
      <Icon aria-hidden="true" focusable="false" />
      <span>{children}</span>
    </span>
  );
}
